import {Injectable} from '@angular/core';


import {GlobalService} from "@iw-shop/core/services/global.service";

@Injectable({
    providedIn: 'root'
})
export class AppInitGlobalService {

    constructor(
        private globalService: GlobalService
    ) {
    }

    init() {
        return new Promise<void>(async resolve => {
            await this.globalService.setGroups().then();
            await this.globalService.setDynamicPageLinks().then();
            resolve();
        });
    }
}
